import { useState } from "react"

const ContactUsForm = () => {
    // let [userName, setUserName] =useState('')
    // let [email, setEmail] =useState('')
    // setUserName(e.target.name)
    const [formData, setFormData] = useState({
        userName: '', email: '', phone: '', message: ''
    })
    const { userName, email, phone, message } = formData //sirf bar bar na likhny k liy

    const handleChange = (e) => {

        const { name, value, checked } = e.target //sirf bar bar na likhny k liy
        // let name = e.target.name
        // if(name=='email'){
        //     setEmail(value)
        // }
        // else{
        //     setName(value)
        // }

        setFormData({
            ...formData, // rest Opperator to inclue other objects also
            [name]: value
        })
    }

    console.log({ formData })

    return (
        <>
            <form>
                <input className="contact-input" type="text" name="userName" value={userName} onChange={handleChange} placeholder="Your Name" required />
                <br />
                <input className="contact-input" type="text" name="email" value={email} placeholder="Email" onChange={handleChange} required />
                <br />
                <input className="contact-input" type="text" name="phone" value={phone} onChange={handleChange} placeholder="Phone Number*" required />
                <br />
                <textarea className="contact-input" placeholder="Message" required />
                <br />
                <input className="contact-input text-white" type="submit" value="Submit" />
            </form>
        </>
    )
}

export default ContactUsForm